import { Boolean, Null, Number, Optional, Record, Static, String, Union, Unknown } from 'runtypes';

import { ResultDirectionEnum as _ResultDirection } from 'src/models/activity/enums';
import { ArchivButtonRunType } from 'src/models/archiv';
import { createEnumGuard } from 'src/models/enumGuard';
import { GlobalizationButtonRunType } from 'src/models/globalization';
import { IdoButtonRunType } from 'src/models/ido';
import { MessageListExtrasRunType } from 'src/models/messageList/extras';
import { ModuleNameRunType } from 'src/models/module';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';

const ResultDirectionRunType = createEnumGuard(Object.values(_ResultDirection) as _ResultDirection[]);

export const MessageListItemRunType = Record({
	accessRight: Boolean,
	aggregateId: String,
	aggregateVersion: Number,
	archivButton: ArchivButtonRunType,
	archived: Boolean,
	channel: String,
	channelQTip: Null,
	contact: String.Or(Null),
	contactPicture: String.Or(Null),
	contactQTip: String.Or(Null),
	context: String.Or(Null),
	contextQTip: String.Or(Null),
	date: String,
	directAccessUser: String.Or(Null),
	direction: ResultDirectionRunType,
	directionQTip: Null,
	extras: MessageListExtrasRunType,
	globalizationButton: GlobalizationButtonRunType,
	globalized: Boolean,
	groupedStatus: Null,
	idoButton: IdoButtonRunType,
	idoLinked: Boolean,
	information: String.Or(Null),
	informationQTip: String.Or(Null),
	moduleName: ModuleNameRunType,
	moduleSort: Number.Or(Null),
	processId: String,
	spoingButton: Union(SpoingButtonRunType).Or(Record({})),
	status: Number,
	statusButton: StatusButtonRunType,
	taskButton: Optional(TaskButtonRunType).Or(Null).Or(Unknown),
	timeFrame: Number,
	timestamp: Number,
});

export type MessageListItem = Static<typeof MessageListItemRunType>;
